export const CE_OPEN_DIALOG = "CE_OPEN_DIALOG";
